import React from 'react';
import ShareOptions from '../ShareOptions';


import * as actions from '../Actions';
export default function ({ feedItem, eleRef, GTMlike, gtmShare }) {
    return (
             <div>     
                        <div className="main_block_container_feed article-component">
                        <div className="block_container_feed_heading_text mo_padr-top12 R15_61">
                           {(feedItem.title)?feedItem.title:''}
                         </div>
                         <div className="content-div-box-artical">
                             <div className="content-div_view_artical">
                                <a href={feedItem.data[0].articleUrl}>
                                    <img className='gtm-article-click' src={feedItem.data[0].articleImage?feedItem.data[0].articleImage:"https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png"} onError={(e) => { e.target.src = "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/no-image.png"}}  alt="" />
                                 </a>
                             </div>
                             <div className="the_week_game_vido"> 
                                 <a href={feedItem.data[0].articleUrl} className="fabulous_text gtm-article-click" dangerouslySetInnerHTML={ {__html: feedItem.data[0].Title?feedItem.data[0].Title:''} } />
                                
                                     {/* {(feedItem.data[0].Title)?feedItem.data[0].Title:''}</a> */}
                                 <div className="week_card-text more"> 
                                      <span className="R15_61 game-discription-text">{(feedItem.data[0].discription)?feedItem.data[0].discription:''}</span>
                                      <a href={feedItem.data[0].articleUrl} className="gtm-article-readmore readmorelink R14_link"> Read more</a>
                                 </div>
                             </div>
                             <div className="bottom_line_divider_feed"> </div>
                                  <div className="baby-week-social-view hightlighted-social-view"> 
                                     <div className="post-options">
                                       <div className="icon left devMemoLike font-sizeview" data-icon-font="$" >
                                        <span className="icons-text R13_61">{feedItem.data[0].viewCount}</span>
                                        </div>
                                        <div className={`left ${(feedItem.data[0].isLiked?'active':'')}`} >
                                            <span data-icon-font="" className={`${GTMlike} icon likesIcon`} onClick={(e) => actions.likeArticle(feedItem.data[0].articleId, e, feedItem.data[0].likeCount)}></span>
                                            <span onClick={(e) => actions.getAnswerLikeUsersArticle(e,feedItem.data[0].articleId, feedItem.data[0].likeCount)} className="icons-text R13_61">{feedItem.data[0].likeCount} <span className='mLike'>Likes</span></span>
                                        </div>
                                     </div>
                                     <div className="m-abuse-main right" id={`share_${feedItem.data[0].articleId}`}>
                                         <div className="icon left icon3dot facebookicons" data-icon-font="J"></div>
                                         <div className="icon left icon3dot whatsapp-icons" data-icon-font="" onClick={() => actions.shareOn(feedItem.data[0].articleId)}> <span className={`icons-text R14_61 cursor-pointer ${gtmShare}`}> Share </span></div>
                                         <ShareOptions feedItem={feedItem} eleRef={this} />
                                     </div>
                                 </div>
                             </div>

                             </div>
</div>   

            )
        }
